import React from 'react';
import './LandingPage.css';

export default function Meeting() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Meeting</h1>
      <p>Manage meetings (placeholder).</p>
    </main>
  );
}
